export function initChildrenOnScrollAnimation() {
    const container = document.querySelector('.blueprintImageWithText');
    if (!container) return;

    const children = container.querySelectorAll('.blueprintImageWithText__item');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                children.forEach((child) => {
                    if (entry.isIntersecting) {
                        child.style.top = "0";
                    } else {
                        child.style.top = "";  // Auf ursprünglichen Wert zurücksetzen
                    }
                });
            });
        },
        {
            threshold: 0,       // Greift sobald auch nur 1px sichtbar ist
            rootMargin: "-35%",  // Kein Puffer – echter Viewport-Rand
        }
    );

    observer.observe(container);
}